<div class="sector-calendar">
  <div class="calendar-info-header" *ngIf="selectedSector">
    <!-- Первая строка: Дата и Участок -->
    <div class="header-row">
      <div class="header-date">Статистика на {{ formattedSelectedDate }}</div>
      <div class="header-sector-container">
        <span class="sectors-label">Участок:</span>
        <div class="sectors-list">
          <a
            *ngFor="let sector of sectors"
            class="sector-link"
            [ngClass]="{
              'sector-link--active': selectedSector && sector.sector_id === selectedSector.sector_id,
              'sector-link--inactive': !selectedSector || sector.sector_id !== selectedSector.sector_id
            }"
            (click)="onSelectSector(sector)"
          >
            {{ sector.sector_number_str }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="header-section-separator" *ngIf="selectedSector"></div>

  <div class="calendar-info-header" *ngIf="selectedSector">
    <div class="header-row">
      <div class="header-workload">Загруженность: {{ selectedDayWorkloadPercent }}%</div>
      <a class="header-link" (click)="openTicketsView()">Смотреть заявки</a>
    </div>

    <!-- Название района -->
    <div class="header-row" *ngIf="districts.length > 0">
      <div class="header-district-container">
        <div class="header-district-label">
          <span class="sectors-label">Название района:</span>
        </div>

        <div class="districts-dropdown">
          <select class="district-select" [value]="selectedDistrict?.d_id || ''" (change)="onDistrictChange($event)">
            <option value="">Все районы</option>
            <option *ngFor="let district of districts" [value]="district.d_id">
              {{ district.district_name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="sectors-loading" *ngIf="loading">
    <span class="color-gray-dark">Загрузка участков...</span>
  </div>

  <!-- Индикатор загрузки данных -->
  <div class="calendar-loading" *ngIf="loadingHeatMap">
    <app-loader></app-loader>
    <span class="color-gray-dark">Загрузка данных о загруженности...</span>
  </div>

  <div class="calendar-grid" *ngIf="!loadingHeatMap">
    <!-- Текущий месяц -->
    <div class="calendar-month">
      <div class="calendar-header">
        <h3 class="calendar-title">{{ currentMonthName }}</h3>
      </div>

      <div class="calendar-weekdays">
        <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
      </div>

      <div class="calendar-days">
        <div *ngFor="let day of currentMonthDays" [ngClass]="getDayClasses(day)" (click)="onDayClick(day)">
          <span class="day-number" *ngIf="day">{{ day.dayNumber }}</span>
          <div *ngIf="day && day.hasData && day.workload >= 0" class="workload-indicator" [ngClass]="getWorkloadClass(day.workload)"></div>
        </div>
      </div>
    </div>

    <!-- Следующий месяц -->
    <div class="calendar-month">
      <div class="calendar-header">
        <h3 class="calendar-title">{{ nextMonthName }}</h3>
      </div>

      <div class="calendar-weekdays">
        <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
      </div>

      <div class="calendar-days">
        <div *ngFor="let day of nextMonthDays" [ngClass]="getDayClasses(day)" (click)="onDayClick(day)">
          <span class="day-number" *ngIf="day">{{ day.dayNumber }}</span>
          <div *ngIf="day && day.hasData && day.workload >= 0" class="workload-indicator" [ngClass]="getWorkloadClass(day.workload)"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Легенда загруженности -->
  <div class="workload-legend">
    <div class="workload-items">
      <div class="workload-item">
        <div class="workload-badge workload-badge--low">01</div>
        <span>Занято меньше половины</span>
      </div>
      <div class="workload-item">
        <div class="workload-badge workload-badge--medium">02</div>
        <span>Занято больше половины</span>
      </div>
      <div class="workload-item">
        <div class="workload-badge workload-badge--high">03</div>
        <span>Занято все</span>
      </div>
    </div>
    <div class="day-statistics">
      <app-day-statistics [statistics]="dayStatistics" [selectedDate]="selectedDate" [selectedSector]="selectedSector" [workloadData]="dayWorkload" [loading]="loadingStatistics">
      </app-day-statistics>
    </div>
  </div>
</div>
